<app-page-heading [key]="'decarbonization.title'"></app-page-heading>

<section class="container-fluid flex-row">
    <app-decarbonization-vehicle-type-list
        [regions]="regions"
        [canCreateDecarbonizationTypes]="canCreateDecarbonizationTypes()"
        [canManageRegionDecarbonizationTypes]="canManageRegionDecarbonizationTypes()">
    </app-decarbonization-vehicle-type-list>
    <app-decarbonization-fuel-type-list
        [regions]="regions"
        [canCreateDecarbonizationTypes]="canCreateDecarbonizationTypes()"
        [canManageRegionDecarbonizationTypes]="canManageRegionDecarbonizationTypes()">
    </app-decarbonization-fuel-type-list>
</section>

